import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import moment from 'angular-moment';
import routing from './monthly_demand_report.routes';
import DailyMaxDemandPowerService from '../../../components/api/daily_max_demand_power/daily_max_demand_power.service';
import DemandPowerService from '../../../components/api/demand_power/demand_power.service';
import DailyWeatherService from '../../../components/api/daily_weather/daily_weather.service';
import WeatherService from '../../../components/api/weather/weather.service';
import CompareWeatherLogic from '../../../components/logic/compare_weather/compare_weather.logic';
import PowerFormatter from '../../../components/logic/power-formatter/power-formatter.logic';
import Chart from '../../../components/directive/chart/chart.directive';
import DateUtil from '../../../components/logic/date_util/date_util.module';
import CsvUtil from '../../../components/logic/csv_util/csv.util';
import chartConfig from './monthly_demand_report.config';

export class monthlyDemandReportController {
  /*@ngInject*/
  constructor($stateParams, $q, $filter, $state, moment, PowerFormatter, DailyMaxDemandPowerService, DemandPowerService, DateUtil, CsvUtil, DailyWeatherService, CompareWeatherLogic, WeatherService) {
    this.id = $stateParams.id;
    this.$q = $q;
    this.$filter = $filter;
    this.$state = $state;
    this.moment = moment;
    this.DailyMaxDemandPowerService = DailyMaxDemandPowerService;
    this.DemandPowerService = DemandPowerService;
    this.WeatherService = WeatherService;
    this.DailyWeatherService = DailyWeatherService;
    this.CompareWeatherLogic = CompareWeatherLogic;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;
    this.CsvUtil = CsvUtil;

    this.today = new Date();
    this.targetDate = $stateParams.target || this.today;
    $stateParams.target = null;

    this.maxDate = this.moment().startOf('day').toDate();

    this.categories = [];
    this.downloadFileName = 'demand_power.csv';
    this.bulkDownloadFileName = 'demand_power.csv';
    this.bulkCsvGenerator = () => {
      return this.createBulkCsv();
    };
    this.downloading = false;

    this.chartConfig = chartConfig(this);
  }

  $onInit() {
    this.parentComponent.saConfigPromise.then(config => {
      this.contractPower = config.contract_power;
      this.limitPower = config.limit_power;
      this.targetPower = config.target_power;
      this.billingDay = config.billing_date;

      this.updateGraph(this.targetDate, this.billingDay);
    });
  }

  updateGraph(targetDate, billingDate) {
    [this.startDate, this.endDate] = this.DateUtil.getBillingDateDomain(targetDate, billingDate);

    this.billingDate = this.moment(this.endDate).add(1, 'days').toDate();

    let contractPowers = [];
    let limitPowers = [];
    let targetPowers = [];
    let numberOfDays = (this.endDate - this.startDate) / (24 * 60 * 60 * 1000);

    for (let i = 0; i <= numberOfDays + 1; i++) {
      contractPowers.push(this.contractPower);
      limitPowers.push(this.limitPower);
      targetPowers.push(this.targetPower);
    }

    this.categories = [];
    let startUtc = this.DateUtil.localToUTC(this.startDate);
    for (let i = 0; i <= numberOfDays; i++) {
      this.categories.push(this.DateUtil.leapDate(startUtc, i).valueOf());
    }

    const powerQuery = angular.extend({id: this.id}, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate));
    const weatherQuery = angular.extend({sa_config_id: this.id}, this.DateUtil.getDateRangeQueries(this.startDate, this.endDate));
    this.$q.all([
      this.DailyMaxDemandPowerService.show(powerQuery).$promise,
      this.DailyWeatherService.api.index(weatherQuery).$promise
    ]).then(responses => {
      const powers = responses[0];
      const weathers = responses[1];

      this.chart.series[1].setData(targetPowers, false);
      this.chart.series[2].setData(limitPowers, false);
      this.chart.series[3].setData(contractPowers, false);

      this.demandPowerObjects = this.PowerFormatter.formatDailyDemandPowers(powers.powers, this.categories);
      this.demandPowers = this.demandPowerObjects.map(power => {return power.y});

      this.weathers = this.CompareWeatherLogic.compareDaily(weathers, this.categories);
      const y = (this.weathers.length > 0) ? 36 : null;

      this.chart.xAxis[0].update({
        categories: this.categories,
        max: numberOfDays,
        labels: {y: y}
      });

      this.itemWidth = 100 / numberOfDays;

      this.csvData = this.CsvUtil.processMaxDemandPower(this.demandPowers, this.categories, this.weathers);
      this.chart.series[0].setData(this.demandPowerObjects);
      this.chart.reflow();
      this.maxPower = Math.max.apply(null, this.demandPowers);

      const date = this.moment(this.startDate);
      this.downloadFileName = date.format('[demand_power_]YYYY-MM[_daily.csv]');
      this.bulkDownloadFileName = date.format('[demand_power_]YYYY-MM[_hourly.csv]');
    });
  }

  createBulkCsv() {
    this.downloading = true;
    const startDate = this.moment(this.startDate);
    const endDate = this.moment(this.endDate).add(1, 'day');
    const powerQuery = angular.extend({id: this.id}, this.DateUtil.datetimeRangeQuery(startDate, endDate));
    const weatherQuery = angular.extend({sa_config_id: this.id}, this.DateUtil.getDateRangeQueries(startDate, endDate.subtract(1, 'day')));

    return new Promise(resolve => {
      this.$q.all([
        this.DemandPowerService.show(powerQuery).$promise,
        this.WeatherService.api.index(weatherQuery).$promise
      ]).then(responses => {
        resolve(this.CsvUtil.processBulkDemandPower(responses[0].powers, responses[1]));
        this.downloading = false;
      });
    });
  }

  changeMonth(diff) {
    this.targetDate = this.DateUtil.leapMonth(this.targetDate, diff);

    this.updateGraph(this.targetDate, this.billingDay);
  }
}

export default angular.module('leptonApp.monthlyDemandReport', [uiRouter, moment, PowerFormatter, DailyMaxDemandPowerService, DemandPowerService, Chart, DateUtil, CsvUtil, DailyWeatherService, CompareWeatherLogic, WeatherService])
  .config(routing)
  .component('monthlyDemandReport', {
    require: {parentComponent: '^demandReportShow'},
    template: require('./monthly_demand_report.html'),
    controller: monthlyDemandReportController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/monthly/monthly_demand_report.component.js